export default __webpack_public_path__ + "static/UK--2x-56016d4af4acd3a72ea229f6c10f4974.png";